import React from 'react';
import { Shield, CreditCard, Award, CheckCircle } from 'lucide-react';

const TrustBadges = () => {
  return (
    <div className="bg-gray-50 py-6 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="flex items-center justify-center">
            <div className="flex items-center space-x-2">
              <Shield className="h-5 w-5 text-ta-green" />
              <span className="text-xs text-gray-600">Secure Payments</span>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <div className="flex items-center space-x-2">
              <CreditCard className="h-5 w-5 text-ta-green" />
              <span className="text-xs text-gray-600">SSL Encrypted</span>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <div className="flex items-center space-x-2">
              <Award className="h-5 w-5 text-ta-green" />
              <span className="text-xs text-gray-600">Licensed Guides</span>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <div className="flex items-center space-x-2">
              <CheckCircle className="h-5 w-5 text-ta-green" />
              <span className="text-xs text-gray-600">Verified Reviews</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBadges;